<mat-card class="cb-margin flex-col flex">
    <mat-card-header>
        <mat-card-title>{{dto.name}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="flex">
        <ng-container>
            <div class="flex-col">
                <cb-display-value-new label="Lot">{{dto.projectStatus}}</cb-display-value-new>
                <cb-display-value-new label="Lot">{{dto.lot}}</cb-display-value-new>
                <cb-display-value-new label="Suburb">{{dto.suburb}}</cb-display-value-new>
                <cb-display-value-new label="City">{{dto.city}}</cb-display-value-new>
            </div>
        </ng-container>
    </mat-card-content>
    <mat-divider class="card-divider"></mat-divider>
    <mat-card-actions class="end-center flex-row">
        <button mat-stroked-button
                color="accent"
                (click)="viewProject(dto.id)">
            <mat-icon>pageview</mat-icon>
            &nbsp;View
        </button>
    </mat-card-actions>
</mat-card>